export default __webpack_public_path__ + "static/media/1.7de24f7c.jpg";